import React from 'react';
import { 
  HelpCircle, 
  Briefcase,
  Scale, 
  ShieldCheck, 
  Clock, 
  FileSpreadsheet, 
  Package, 
  Smartphone 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Scale,
      title: 'Проверяйте вес дома',
      description: 'Взвешивайте багаж заранее дома, чтобы избежать доплат в аэропорту.'
    },
    {
      icon: Briefcase,
      title: 'Упаковка багажа',
      description: 'Тяжелые вещи кладите в ручную кладь, а объемные, но легкие в багаж.'
    },
    {
      icon: Package,
      title: 'Компактное хранение',
      description: 'Используйте вакуумные пакеты для одежды, чтобы сэкономить место.'
    },
    {
      icon: FileSpreadsheet,
      title: 'Изучите правила',
      description: 'Каждая авиакомпания имеет свои правила провоза багажа и ручной клади.'
    },
    {
      icon: ShieldCheck,
      title: 'Ценные вещи',
      description: 'Документы, деньги, ноутбук и другие ценности всегда берите в ручную кладь.'
    },
    {
      icon: Clock,
      title: 'Раннее бронирование',
      description: 'При бронировании билета заблаговременно оплачивайте провоз доп. багажа, это дешевле.'
    },
    {
      icon: Smartphone,
      title: 'Мобильное приложение',
      description: 'Установите мобильное приложение авиакомпании для доступа к правилам и бонусной программе.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-purple-500" />
        Советы по багажу
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-purple-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <ShieldCheck className="w-5 h-5 text-purple-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-purple-700 dark:text-purple-300 mb-2">
              Помните о безопасности
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400 mb-3">
              Не перевозите запрещенные предметы и жидкости более 100 мл в ручной клади. Следуйте инструкциям по безопасной упаковке багажа.
            </p>
            <a 
              href="#" 
              className="block w-full py-1.5 text-xs bg-purple-500 text-white text-center rounded hover:bg-purple-600 transition-colors"
            >
              Подробнее о правилах
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;